// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".left-placeholder[data-v-d5365ec4],.right-placeholder[data-v-d5365ec4]{flex-shrink:0;scroll-snap-align:start}.right-placeholder[data-v-d5365ec4]{scroll-snap-align:end}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
